@if (application(); as application) {
  <h3>
    Wnioskodawca
  </h3>
  <app-accordion-group>
    @for (investor of application.applicants; track $index) {
      <app-accordion-item
        [disabled]='false'
        [name]='$index + 1 + ". " + (investor | entityLabel)'
        [expanded]='expanded'>
        <app-opinion-on-issuing-a-decision-investor-item-preview [investor]="investor">
        </app-opinion-on-issuing-a-decision-investor-item-preview>
      </app-accordion-item>
    }
  </app-accordion-group>
}
